import { formatClock } from "../store/takes";

export { formatClock };

export function el<T extends HTMLElement>(id: string): T {
  const node = document.getElementById(id);
  if (!node) throw new Error(`missing element #${id}`);
  return node as T;
}

export function on<K extends keyof HTMLElementEventMap>(
  node: HTMLElement | Window | Document,
  type: K | string,
  handler: (event: HTMLElementEventMap[K]) => void,
  options?: AddEventListenerOptions | boolean,
): void {
  node.addEventListener(type, handler as EventListener, options);
}

export function toast(message: string, kind: "info" | "ok" | "error" = "info"): void {
  const host = document.getElementById("toasts");
  if (!host) return;
  // One line per distinct message: the same failure firing five times is noise.
  for (const existing of host.querySelectorAll<HTMLElement>(".toast")) {
    if (existing.textContent?.split(" ×")[0] === message) {
      const count = Number(existing.dataset.repeat ?? "1") + 1;
      existing.dataset.repeat = String(count);
      existing.textContent = `${message} ×${count}`;
      return;
    }
  }
  const node = document.createElement("div");
  node.className = `toast ${kind === "info" ? "" : kind}`.trim();
  node.textContent = message;
  host.append(node);
  window.setTimeout(() => {
    node.style.opacity = "0";
    node.style.transition = "opacity 0.25s ease";
    window.setTimeout(() => node.remove(), 300);
  }, kind === "error" ? 7000 : 4000);
}

export function showBanner(text: string, action?: { label: string; run: () => void }): void {
  const banner = document.getElementById("banner");
  const label = document.getElementById("banner-text");
  const actionButton = document.getElementById("banner-action") as HTMLButtonElement | null;
  if (!banner || !label || !actionButton) return;
  label.textContent = text;
  if (action) {
    actionButton.hidden = false;
    actionButton.textContent = action.label;
    actionButton.onclick = () => {
      action.run();
      hideBanner();
    };
  } else {
    actionButton.hidden = true;
    actionButton.onclick = null;
  }
  banner.hidden = false;
}

export function hideBanner(): void {
  const banner = document.getElementById("banner");
  if (banner) banner.hidden = true;
}


export function formatWhen(timestamp: number): string {
  const date = new Date(timestamp);
  return date.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}
